import React from 'react';
import { Button, Container, Grid, Text } from 'basis';
import { Modal } from 'components/modal/Modal';

const formatAmount = amount => `$${Math.round(amount || 0).toLocaleString('en-AU')}`;

export const ExpenseIncomeWarningModal = ({ isOpen, onClose, onSubmit, monthlyExpenses, monthlyIncome, warning }) => {
  if (!warning) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{ maxWidth: 960 }}>
      <Container padding="10 8 8">
        <Text textStyle="heading5" align="center">
          {warning.title}
        </Text>
        <Container padding="6 0 8">
          <Grid colsGap="2">
            <Grid.Item colSpan="0-2">
              <Text>Living and housing:</Text>
            </Grid.Item>
            <Grid.Item colSpan="3">
              <Text align="right" textStyle="body2Strong">
                {formatAmount(monthlyExpenses)}
              </Text>
            </Grid.Item>
            <Grid.Item colSpan="0-2">
              <Text>Income:</Text>
            </Grid.Item>
            <Grid.Item colSpan="3">
              <Text align="right" textStyle="body2Strong">
                {formatAmount(monthlyIncome)}
              </Text>
            </Grid.Item>
          </Grid>
          <Container padding="6 0 0">
            <Text>{warning.message}</Text>
          </Container>
        </Container>
        <Grid cols="1fr" cols-sm="1fr 1fr" colsGap="4" rowsGap="4">
          <Button width="100%" onClick={onSubmit}>
            Next
          </Button>
          <Button width="100%" type="button" variant="secondary" onClick={onClose}>
            {warning.editButtonText || 'Edit'}
          </Button>
        </Grid>
      </Container>
    </Modal>
  );
};
